import { DesktopModalSize, MobileModalSize, ModalSize } from '../../../utils/modalSize';
import { InstallmentPaymentMethod } from '../../../types/InstallmentPaymentMethod';
import { DeviceType } from '../../../types/DeviceType';

export const AFFIRM_MODAL_SIZE: Record<DeviceType, ModalSize> = {
  desktop: DesktopModalSize[InstallmentPaymentMethod.Affirm],
  mobile: MobileModalSize,
};
